(function () {
  'use strict';

  const root =
    window.Shopify?.routes?.root || '/';

  const drawer = document.getElementById('PrimeDrawer');
  const overlay = document.getElementById('PrimeDrawerOverlay');
  const itemsContainer = document.getElementById('PrimeDrawerItems');
  const subtotal = document.getElementById('PrimeSubtotal');
  const count = document.getElementById('pd-count');

  if (!drawer || !overlay || !itemsContainer) return;

  function escapeHtml(value) {
    const element = document.createElement('div');
    element.textContent = value || '';
    return element.innerHTML;
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR'
    }).format((Number(cents) || 0) / 100);
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('pd-cart-open');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('pd-cart-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  function updateThemeCounters(itemCount) {
    const selectors = [
  '[data-cart-count]',
  '.cart-count-bubble span',
  '.cart-count',
  '[data-header-cart-count]',
  '[data-pd-cart-count]'
];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        element.textContent = itemCount;
        element.hidden = itemCount <= 0;
      });
    });
  }

  function renderCart(cart) {
    if (count) {
      count.textContent = cart.item_count;
    }

    if (subtotal) {
      subtotal.textContent = formatMoney(cart.total_price);
      function formatMoneyWithCurrency(cents) {
  const currency =
    window.Shopify?.currency?.active ||
    window.Shopify?.currency?.current ||
    'EUR';

  const symbolMap = {
    EUR: '€',
    USD: '$',
    CAD: '$',
    AUD: '$',
    GBP: '£',
    CHF: 'CHF ',
    JPY: '¥',
    CNY: '¥',
    SEK: 'kr ',
    NOK: 'kr ',
    DKK: 'kr '
  };

  const symbol = symbolMap[currency] || `${currency} `;

  const amount = new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format((Number(cents) || 0) / 100);

  return `${symbol}${amount} ${currency}`;
}
    }

    updateThemeCounters(cart.item_count);

    if (!cart.items.length) {
      itemsContainer.innerHTML =
        '<p class="pd-empty">Votre panier est vide.</p>';

      return;
    }

    itemsContainer.innerHTML = cart.items
      .map(function (item) {
        const image = item.image
          ? `
            <a href="${escapeHtml(item.url)}">
              <img
                class="pd-item-image"
                src="${escapeHtml(item.image)}"
                alt="${escapeHtml(item.product_title)}"
                loading="lazy"
              >
            </a>
          `
          : '<div class="pd-item-image"></div>';

        const variant =
          item.variant_title &&
          item.variant_title !== 'Default Title'
            ? `
              <p class="pd-item-variant">
                ${escapeHtml(item.variant_title)}
              </p>
            `
            : '';

        const vendor = item.vendor
          ? `
            <p class="pd-item-vendor">
              ${escapeHtml(item.vendor)}
            </p>
          `
          : '';

        return `
          <article class="pd-item">
            ${image}

            <div class="pd-item-content">
              ${vendor}

              <a
                href="${escapeHtml(item.url)}"
                class="pd-item-title"
              >
                ${escapeHtml(item.product_title)}
              </a>

              ${variant}

              <div class="pd-item-price">
                ${formatMoney(item.final_price)}
              </div>

              <div class="pd-item-actions">
                <div class="pd-quantity">
                  <button
                    type="button"
                    data-pd-minus
                    data-line-key="${escapeHtml(item.key)}"
                    data-quantity="${item.quantity}"
                    aria-label="Réduire la quantité"
                  >
                    −
                  </button>

                  <span>${item.quantity}</span>

                  <button
                    type="button"
                    data-pd-plus
                    data-line-key="${escapeHtml(item.key)}"
                    data-quantity="${item.quantity}"
                    aria-label="Augmenter la quantité"
                  >
                    +
                  </button>
                </div>

                <button
                  type="button"
                  class="pd-remove"
                  data-pd-remove
                  data-line-key="${escapeHtml(item.key)}"
                >
                  Supprimer
                </button>
              </div>
            </div>
          </article>
        `;
      })
      .join('');
  }

  async function fetchCart() {
    const response = await fetch(root + 'cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Impossible de charger le panier.');
    }

    const cart = await response.json();
    renderCart(cart);
    return cart;
  }

  async function changeItem(lineKey, quantity) {
    if (!lineKey) return;

    drawer.classList.add('is-loading');

    try {
      const response = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: Math.max(0, quantity)
        })
      });

      const cart = await response.json();

      if (!response.ok || cart.status) {
        throw new Error(
          cart.description ||
          'Impossible de modifier le panier.'
        );
      }

      renderCart(cart);
    } catch (error) {
      console.error(error);
      window.alert(error.message);
    } finally {
      drawer.classList.remove('is-loading');
    }
  }

  async function addFormToCart(form, submitButton) {
    const originalText =
      submitButton?.tagName === 'BUTTON'
        ? submitButton.textContent
        : '';

    if (submitButton) {
      submitButton.disabled = true;

      if (submitButton.tagName === 'BUTTON') {
        submitButton.textContent = 'Ajout…';
      }
    }

    try {
      const formData = new FormData(form);

      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(
          result.description ||
          'Impossible d’ajouter le produit.'
        );
      }

      const quickModal = form.closest('.pd-quick-modal');

      if (quickModal) {
        quickModal.hidden = true;
        document.body.classList.remove('pd-modal-open');
      }

      await fetchCart();
      openDrawer();
    } catch (error) {
      console.error(error);
      window.alert(error.message);
    } finally {
      if (submitButton) {
        submitButton.disabled = false;

        if (
          submitButton.tagName === 'BUTTON' &&
          originalText
        ) {
          submitButton.textContent = originalText;
        }
      }
    }
  }

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target.closest(
        'form[action*="/cart/add"], [data-pd-quick-form]'
      );

      if (!form) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const submitButton =
        event.submitter ||
        form.querySelector(
          'button[type="submit"], input[type="submit"]'
        );

      addFormToCart(form, submitButton);
    },
    true
  );

  document.addEventListener('click', function (event) {
    const clickedOutsideDrawer =
  drawer.classList.contains('is-open') &&
  !event.target.closest('#PrimeDrawer');

if (
  event.target.closest('.pd-close') ||
  event.target.closest('#PrimeDrawerOverlay') ||
  clickedOutsideDrawer
) {
  closeDrawer();
  return;
}

    const minus = event.target.closest('[data-pd-minus]');

    if (minus) {
      changeItem(
        minus.dataset.lineKey,
        (Number(minus.dataset.quantity) || 1) - 1
      );
      return;
    }

    const plus = event.target.closest('[data-pd-plus]');

    if (plus) {
      changeItem(
        plus.dataset.lineKey,
        (Number(plus.dataset.quantity) || 0) + 1
      );
      return;
    }

    const remove = event.target.closest('[data-pd-remove]');

    if (remove) {
      changeItem(remove.dataset.lineKey, 0);
      return;
    }

    const checkout = event.target.closest('.pd-checkout-btn');

    if (checkout) {
      window.location.href = root + 'checkout';
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawer();
    }
  });

  fetchCart().catch(console.error);


    
  window.PrimeDecoCart = {
    open: async function () {
      await fetchCart();
      openDrawer();
    },
    close: closeDrawer,
    refresh: fetchCart
  };
})();